import React, { useEffect, useMemo, useState } from 'react';

const InfiniteCarousel = ({
  images = [],
  height = { base: 320, md: 420 },
  gapPx = 24,
  repeat = 3,
  durationSec = 40,
}) => {
  const duplicated = useMemo(
    () => Array.from({ length: repeat }).flatMap(() => images),
    [images, repeat]
  );

  useEffect(() => {
    const distance = ((repeat - 1) / repeat) * 100;
    const keyName = `marqueeX_r${repeat}`;
    const id = `kf-${keyName}`;
    if (!document.getElementById(id)) {
      const style = document.createElement('style');
      style.id = id;
      style.innerHTML = `@keyframes ${keyName} { 0% { transform: translateX(0); } 100% { transform: translateX(-${distance}%); } }`;
      document.head.appendChild(style);
    }
  }, [repeat]);

  const hBase = height.base || 500;
  const hMd = height.md || 500;
  const [gap, setGap] = useState(gapPx);
  const [isSm, setIsSm] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 640 : false
  );
  useEffect(() => {
    const updateGap = () =>
      setGap(window.innerWidth < 768 ? Math.max(8, gapPx - 8) : gapPx);
    updateGap();
    window.addEventListener('resize', updateGap);
    return () => window.removeEventListener('resize', updateGap);
  }, [gapPx]);

  useEffect(() => {
    const onResize = () => setIsSm(window.innerWidth < 640);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const keyName = `marqueeX_r${repeat}`;
  return (
    <div className="relative mt-6 w-screen left-1/2 -translate-x-1/2">
      <div className="overflow-hidden">
        <div
          className="flex"
          style={{
            gap: `${gap}px`,
            width: isSm ? `${duplicated.length * 50}%` : `${repeat * 100}%`,
            animation: `${keyName} ${durationSec}s linear infinite`,
            willChange: 'transform',
          }}
        >
          {duplicated.map((src, i) => (
            <div
              key={i}
              style={{
                flex: '0 0 auto',
                width: `${100 / (images.length * repeat)}%`,
              }}
            >
              <img
                src={src}
                alt={`slide-${i + 1}`}
                className={`w-full object-cover`}
                style={{ height: `${hBase}px` }}
              />
              <style>{`@media (min-width: 768px){ img[alt="slide-${i + 1}"] { height: ${hMd}px !important; } }`}</style>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const LimitedEdition = () => {
  return (
    <div className="px-4 sm:px-6 xl:px-8 overflow-x-hidden">
      <p className="text-[17px] leading-[21px] font-medium text-[#939393] text-center">
        Limited Edition
      </p>
      <h3 className="mt-[24px] mb-10 libre-baskerville font-normal text-[32px] sm:text-[60px] leading-[40px] sm:leading-[70px] md:text-[78px] md:leading-[94px] text-[#1D1D1F] text-center">
        Oversized Aesthetics
      </h3>
      <div className="h-[400px] md:h-[500px]">
        <InfiniteCarousel
          gapPx={32}
          images={[
            '/assets/wnt3blgg2qid2n4nerxs.webp',
            '/assets/nm1robzp8x0kk3gvq3wy.webp',
            '/assets/wnt3blgg2qid2n4nerxs.webp',
            '/assets/nm1robzp8x0kk3gvq3wy.webp',
          ]}
        />
      </div>
    </div>
  );
};

export default LimitedEdition;
